import axios from "axios";
import axiosInstance from "./axios";
import { ResponseType } from "@/types/CommonTypes";
import { CreateRoleType, RoleType } from "@/types/RoleTypes";
import { PermissionType } from "@/types/PermissionTypes";

export const rolesApi = {
  getAll: async (
    page: number,
    limit: number,
    searchTerm: string,
    sortBy?: string,
    sortDirection?: "ascending" | "descending",
    signal?: AbortSignal,
  ): Promise<ResponseType<RoleType[]>> => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("page", page.toString());
      queryParams.append("limit", limit.toString());
      if (searchTerm && searchTerm !== "") {
        queryParams.append("search", searchTerm);
      }
      if (sortBy) {
        queryParams.append("sort_by", sortBy);
      }
      if (sortDirection) {
        queryParams.append(
          "sort_direction",
          sortDirection === "ascending" ? "ASC" : "DESC",
        );
      }

      const response = await axiosInstance.get(
        `/roles?${queryParams.toString()}`,
        { signal },
      );
      return response.data;
    } catch (error) {
      if (axios.isCancel(error)) throw error;
      throw error;
    }
  },
  getAllActive: async (): Promise<ResponseType<RoleType[]>> => {
    try {
      const response = await axiosInstance.get("/roles/active");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  assignRole: async (
    userId: number,
    roleId: number,
  ): Promise<ResponseType<RoleType>> => {
    try {
      const response = await axiosInstance.post(`/roles/${userId}/assign`, {
        roleId,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async (
    id: number,
    data: RoleType | CreateRoleType,
  ): Promise<ResponseType<RoleType>> => {
    try {
      const response = await axiosInstance.put(`/roles/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  create: async (data: CreateRoleType): Promise<ResponseType<RoleType>> => {
    try {
      const response = await axiosInstance.post("/roles", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getAllPermissions: async (): Promise<ResponseType<PermissionType[]>> => {
    try {
      const response = await axiosInstance.get("/permissions?active=true");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deleteRole: async (roleId: number): Promise<ResponseType<void>> => {
    try {
      const response = await axiosInstance.delete(`/roles/${roleId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getRoleById: async (roleId: number): Promise<ResponseType<RoleType>> => {
    try {
      const response = await axiosInstance.get(`/roles/${roleId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
